export enum PathMatchType {
  Full = 'full'
}
